import React, { useEffect } from "react"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import Img from "./Img"

import * as styles from "./banner.module.scss"
import { useObserver } from "../../../hooks"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

type BannerProps = {
  buttonText?: string
  title?: string
  description?: string
  orderNum?: string
  variantStyle?: string
}

const defaultTitle = `Рассрочка* от&nbsp;10&nbspмесяцев по&nbsp;карте&nbsp;«Халва»`

const defaultDescription = `
  <li>— До 5% к ставке вклада</li>
  <li>— Кэшбэк до 10%</li>
  <li>— Обслуживание 0 ₽</li>
`

export function Banner({
  buttonText = "Оформить карту",
  title = defaultTitle,
  description = defaultDescription,
  orderNum,
  variantStyle,
}: BannerProps) {
  useEffect(() => {
    document.body.style.display = "block"
  }, [])
  const isVisible = useObserver([
    "app",
    "calculatorCard",
    "reviewCard",
    "moreBenefits",
    "formPkw",
    "interactive_benefits_block",
    "slider",
    "subscription",
    "download",
  ])

  return (
    <>
      <section className={variantStyle && styles[variantStyle]} data-exclude={orderNum}>
        <Container className={styles.container}>
          <div className={clsx(styles.secondContainer)}>
            <Img alt="bg image" className={styles.img} />
            <div className={styles.text}>
              <h1 dangerouslySetInnerHTML={{ __html: title }} />
              <ul dangerouslySetInnerHTML={{ __html: description }} />
            </div>
            <Button
              disableRipple
              className={styles.btn}
              onClick={() => handleClickBanner(buttonText, "Оформить карту")}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div className={clsx(styles.btnBlock, { [styles.hideMobBlock]: isVisible })}>
        <Container className={styles.stickyContain}>
          <Button disableRipple onClick={() => handleClickStickyBtn()} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
